import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { Warehouse } from '../../models/warehouse.model';
import { WarehouseService } from '../../services/warehouse.service';
import { WarehouseValidatorService } from '../../validators/warehouse-validator.service';

@Component({
    selector: 'app-warehouses-edit',
    templateUrl: './warehouses-edit.component.html',
    styleUrls: ['./warehouses-edit.component.scss'],
    standalone: false
})
export class WarehousesEditComponent implements OnInit {

  warehouse: Warehouse = new Warehouse();

  isError: boolean = false;
  isServerError: boolean = false;
  isSuccess: boolean = false;

  constructor(private route: ActivatedRoute,
    private warehouseValidator: WarehouseValidatorService,
    private warehouseService: WarehouseService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.loadWarehouse(+params['id']);
    })
  }

  loadWarehouse(id: number): void {
    this.warehouseService.getWarehouseById(id)
    .pipe(take(1))
    .pipe(catchError((e) => {
      this.isServerError = true;
      return e;
    }))
    .subscribe((warehouse: Warehouse) => {
      this.warehouse = warehouse;
    })
  }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.isSuccess = false;

    if (this.warehouseValidator.isValid(this.warehouse)) {
      this.warehouseService.updateWarehouse(this.warehouse)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        this.isSuccess = true;
      })
    } else {
      this.isError = true;
    }
  }
}
